import YHeader from './YHeader.vue';
export default YHeader